<template>
	<div class="">
		<el-button type="primary" size="small" @click="add">添加表单</el-button>
		<el-button type="success" size="small" @click="reflash">刷新</el-button>
		<el-button type="info" size="small" @click="clear">初始化</el-button>
		<el-divider>数据关系图</el-divider>
		<div class=" relation" id="relation"></div>
		<div class="minimapContainer" ref="minimapContainer"></div>
		<vue-context-menu :key="menuKey" :contextMenuData="contextMenuData" @modifyTask="modifyTask"
			style="padding: 0 10px;" @editEdge="editEdge" @deleteEdge="deleteEdge" @deleteNode="deleteNode"
			@changeNode="changeNode" @refreshNode="refreshNode" @nodefield="nodefield" @tablenodefield="tablenodefield"
			@customlist="customlist" @listorder="listorder" v-show="menuShow">
		</vue-context-menu>

		<vxe-modal v-model="editShow" @confirm="onEditSubmit" width="1200" height="800" :title="editTitle" show-footer
			transfer show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<edit ref="relationEditForm" :edge="currentEdge" />
			</div>
		</vxe-modal>

		<vxe-modal v-model="changeShow" @confirm="onChangeSubmit" width="300" height="200" :title="changeTitle"
			show-footer transfer show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<change ref="relationChangeForm" :node="currentNode" />
			</div>
		</vxe-modal>

		<vxe-modal v-model="fieldShow" @confirm="onFieldSubmit" width="1200" height="800" :title="fieldTitle"
			show-footer transfer show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<field ref="fieldForm" :node="currentNode" :graph="graph" />
			</div>
		</vxe-modal>

		<vxe-modal v-model="tablefieldShow" @confirm="onTableFieldSubmit" width="1200" height="800"
			:title="tablefieldTitle" show-footer transfer show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<tablefield ref="fieldForm" :node="currentNode" :graph="graph" />
			</div>
		</vxe-modal>

		<vxe-modal v-model="customlistShow" @confirm="onCustomlistSubmit" width="1000" height="800" title="自定义列表字段"
			show-footer transfer show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<el-form :model="customlistValue" label-width="80px" size="mini">
					<el-form-item label="是否启用">
						<el-checkbox v-model="customlistValue.enable">启用</el-checkbox>
						<div style="width: 200px;display: inline-block;margin-left: 20px;">
							<el-input v-model="customlistValue.view" placeholder="请输入视图名称" size="mini"></el-input>
						</div>
						<el-button type="primary" size="mini" style="margin-left: 10px;" @click="getFieldFromView">
							从视图导入</el-button>
					</el-form-item>
					<el-form-item label="列表配置">
						<vJsoneditor v-model="customlistValue.json" height="600px" :options="{mode:'code'}" />
					</el-form-item>
				</el-form>
			</div>
		</vxe-modal>

		<vxe-modal v-model="addShow" @confirm="onAddSubmit" width="300" height="200" title="添加表单" show-footer transfer
			show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<add ref="relationAddForm" />
			</div>
		</vxe-modal>

		<vxe-modal v-model="listorderShow" @confirm="onListorderSubmit" width="800" height="550" title="列表字段顺序"
			show-footer transfer show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<listorder ref="listorder" :node="currentNode" />
			</div>
		</vxe-modal>



	</div>

</template>
<style scoped>
	.relation {
		box-shadow: 0px 0px 6px #909399;

	}

	.minimapContainer {
		position: absolute;
		top: 0;
		right: 0;
		box-shadow: 0px 0px 10px grey;
	}
</style>
<script>
	import {
		Graph,
		Shape
	} from '@antv/x6';

	import vJsoneditor from 'v-jsoneditor'
	import edit from './edit.vue'
	import change from './change.vue'
	import field from './field.vue'
	import tablefield from './tablefield.vue'
	import add from './add.vue'
	import listorder from './listorder.vue'
	export default {
		props: {
			width: {
				type: String,
				default: () => {
					return "800"
				}
			},
			height: {
				type: String,
				default: () => {
					return "500"
				}
			},
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				customlistShow: false,
				listorderShow: false,
				customlistValue: {
					view: '',
					enable: true,
					json: {}
				},
				fieldShow: false,
				fieldTitle: '主表字段',
				tablefieldShow: false,
				tablefieldTitle: '子表字段',
				changeShow: false,
				changeTitle: '替换',
				addShow: false,
				editTitle: '关联关系',
				editShow: false,
				currentEdge: null,
				currentNode: null,
				menuShow: false,
				contextMenuData: {},
				menuKey: Math.random(),
				graph: null,
				viewname: null,
				LINE_HEIGHT: 24,
				NODE_WIDTH: 300
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				this.graph = new Graph({
					scroller: false,
					container: document.getElementById('relation'),
					width: this.width,
					height: this.height,
					snapline: true,
					minimap: {
						width: 200,
						height: 100,
						enabled: true,
						container: this.$refs.minimapContainer,
						graphOptions: {
							async: true,
							// getCellView(cell) {
							// 	if (cell.isNode()) {
							// 		return SimpleNodeView
							// 	}
							// },
							createCellView(cell) {
								if (cell.isEdge()) {
									return null
								}
							},
						}
					},
					connecting: {
						router: {
							name: 'er',
							args: {
								offset: 25,
								direction: 'H',
							},
						},
						createEdge() {
							return new Shape.Edge({
								attrs: {
									line: {
										stroke: '#A2B1C3',
										strokeWidth: 2,
									},
								},
							})
						},
					},
					background: {
						color: '#fffbe6', // 设置画布背景颜色
					},
					grid: {
						size: 10, // 网格大小 10px
						visible: true, // 渲染网格背景
					},
					selecting: {
						enabled: true,
						rubberband: true,
						showNodeSelectionBox: true,
					},
					mousewheel: {
						enabled: true
					},
				})
				//this.graph.zoom(-0.2)
				this.graph.centerContent()
				this.init()


				this.graph.on('node:contextmenu', ({
					e,
					node
				}) => {
					this.reset()
					this.currentNode = node
					//console.log(this.currentNode,this.extra)
					if (node.getData().type == 'box') {
						this.setContextMenuData('box')

						node.attr('rect/fill', 'orange')
						this.$nextTick(() => {
							this.showMenu(e)
						})

					} else {
						
						let name = this.extra.sourcename || this.extra.name
						console.log(this.currentNode.id,name)
						if (this.currentNode.id === ('c_' + name).replace(/([A-Z])/g, "_$1")
						.toLowerCase()) {
							this.setContextMenuData('main')
						} else {
							this.setContextMenuData('node')
						}



						node.attr('rect/fill', 'orange')
						this.$nextTick(() => {
							this.showMenu(e)
						})
					}
				})
				this.graph.on('node:click', ({
					node
				}) => {
					this.currentNode = node
				})

				this.graph.on('edge:contextmenu', ({
					e,
					edge
				}) => {
					this.setContextMenuData('edge')
					this.reset()
					edge.attr('line/stroke', 'orange')
					this.$nextTick(() => {
						this.showMenu(e)
					})
					this.currentEdge = edge
					// edge.prop('labels/0', {
					// 	attrs: {
					// 		body: {
					// 			stroke: 'orange',
					// 		},
					// 	},
					// })
				})
				this.graph.on('blank:mouseup', () => {
					//console.log(e)
					this.menuShow = false
					this.reset()
				})


				this.graph.on('edge:connected', ({
					isNew,
					edge
				}) => {
					if (isNew) {
						edge.replaceData({
							component: 'quote',
							param: {}
						})
						edge.appendLabel('quote')
					}
				})
				// this.graph.on('node:selected', () => {
				// 	this.node = this.graph.getSelectedCells()

				// })
				// this.graph.on('node:unselected', () => {
				// 	this.node = this.graph.getSelectedCells()

				// })
				// this.graph.on('node:mouseup', () => {
				// 	this.change(this.graph.toJSON())
				// })


			})
		},
		watch: {
			value(val) {
				this.graph.fromJSON(val)
				//console.log(val)
			}
		},
		computed: {

		},

		methods: {
			setContextMenuData(type) {
		
				if (type == 'edge') {
					this.contextMenuData = {
						menuName: 'edgeMenu',
						axis: {
							x: null,
							y: null
						},
						menulists: [{
								btnName: "编辑",
								fnHandler: "editEdge",
								icoName: "el-icon-edit-outline"
							},
							{
								btnName: "删除",
								fnHandler: "deleteEdge",
								icoName: "el-icon-delete"
							}
						]
					}
				} else if (type == 'box') {
					this.contextMenuData = {
						menuName: 'edgeMenu',
						axis: {
							x: null,
							y: null
						},
						menulists: [{
							btnName: "替换",
							icoName: "el-icon-edit-outline",
							fnHandler: "changeNode"
						}, {
							btnName: "删除",
							fnHandler: "deleteNode",
							icoName: "el-icon-delete"
						}, {
							btnName: "刷新",
							fnHandler: "refreshNode",
							icoName: "el-icon-refresh-left"
						}]
					}
				} else if (type == 'main') {
				
					this.contextMenuData = {
						menuName: 'edgeMenu',
						axis: {
							x: null,
							y: null
						},
						menulists: [{
							btnName: "字段",
							fnHandler: "nodefield",
							icoName: "el-icon-s-grid"
						}, {
							btnName: "自定义列表字段",
							fnHandler: "customlist",
							icoName: "el-icon-s-grid"
						}, {
							btnName: "列表字段顺序",
							fnHandler: "listorder",
							icoName: "el-icon-s-grid"
						}, {
							btnName: "删除",
							fnHandler: "deleteNode",
							icoName: "el-icon-delete"
						}, {
							btnName: "刷新",
							fnHandler: "refreshNode",
							icoName: "el-icon-refresh-left"
						}]
					}
				} else {
					this.contextMenuData = {
						menuName: 'edgeMenu',
						axis: {
							x: null,
							y: null
						},
						menulists: [{
							btnName: "字段",
							fnHandler: "tablenodefield",
							icoName: "el-icon-s-grid"
						}, {
							btnName: "列表字段顺序",
							fnHandler: "listorder",
							icoName: "el-icon-s-grid"
						}, {
							btnName: "删除",
							fnHandler: "deleteNode",
							icoName: "el-icon-delete"
						}, {
							btnName: "刷新",
							fnHandler: "refreshNode",
							icoName: "el-icon-refresh-left"
						}]
					}
				}
				this.menuKey = Math.random()
			},
			onEditSubmit() {
				this.$refs.relationEditForm.submit()
			},
			del() {
				if (this.currentNode) {
					this.graph.removeCell(this.currentNode.id)
				} else {
					this.$message.error('请选择节点')
				}

			},
			add() {
				this.addShow = true

			},
			onAddSubmit() {
				let data = this.$refs.relationAddForm.submit()
				this.$api.form.getRelation(data.controller, {
					app: data.type,
					isonly: 1
				}).then((res) => {
					let cells = this.getCells(res)
					this.graph.addNodes(cells)
				})

			},
			onChangeSubmit() {
				let data = this.$refs.relationChangeForm.submit()
				this.$api.form.getRelation(this.extra.controll, data).then((res) => {
					let cells = []
					cells = this.getCells(res)
					cells.forEach((item) => {
						if (item.data.type == 'box') {
							let cell = this.graph.getCellById(item.id)
							item.setPropByPath('position', cell.getPropByPath('position'))
							this.graph.removeCell(item.id)
							this.graph.addNode(item)
						}
					})

				})

			},
			onFieldSubmit() {
				this.$refs.fieldForm.submit()
			},
			onTableFieldSubmit() {
				this.$refs.fieldForm.submit()
			},
			onCustomlistSubmit() {
				let nodeData = this.currentNode.getData()
				if (JSON.stringify(this.customlistValue.json) !== '{}' && this.customlistValue.json) {
					nodeData.customColumns = this.customlistValue
				} else {
					nodeData.customColumns = null
				}
			},
			onListorderSubmit() {
				this.$refs.listorder.submit()
			},
			changeNode() {
				this.changeShow = true
			},
			nodefield() {

				this.fieldShow = true
				// let demo = this.graph.getEdges()
				// let Ports = this.currentNode.getPorts()
				// this.currentNode.removePorts(Ports)
				// console.log(demo)
			},
			tablenodefield() {

				this.tablefieldShow = true
				// let demo = this.graph.getEdges()
				// let Ports = this.currentNode.getPorts()
				// this.currentNode.removePorts(Ports)
				// console.log(demo)
			},


			customlist() {
				if (this.currentNode.data.customColumns) {
					this.customlistValue.json = this.currentNode.data.customColumns.json
					this.customlistValue.enable = this.currentNode.data.customColumns.enable
					this.customlistValue.view = this.currentNode.data.customColumns.view
				} else {
					this.customlistValue.json = {}
				}
				this.customlistShow = true
			},
			listorder() {
				this.listorderShow = true
			},
			deleteNode() {
				this.graph.removeCell(this.currentNode.id)
			},
			reflash() {
				this.$api.form.getRelation(this.extra.controll, {
					type: "reflashtotal"
				}).then((res) => {
					let cells = this.getCells(res)
					let currentcells = this.graph.getNodes()
					// console.log(currentcells)
					// console.log(cells)
					cells.forEach((item) => {
						let index = currentcells.findIndex((_item) => {
							return _item.id == item.id
						})
						if (index === -1) {
							this.graph.addNode(item)
						} else {
							let oldData = currentcells[index].data.fields
							let newData = item.data.fields
							oldData.forEach((item) => {
								newData.forEach((_item) => {
									if (item.field == _item.field) {
										_item.visiable = item.visiable
										_item.button = item.button
										_item.popover = item.popover
										_item.defaultvalue = item.defaultvalue
										_item.mountcomponent = item.mountcomponent
										_item.fieldcomponent = item.fieldcomponent
										_item.componentParam = item.componentParam
										_item.listParam = item.listParam
									}

								})

							})

							let currentData = currentcells[index].getData()
							currentData.fields = newData
							// for(let i in currentData){
							// 	if(i!='fields'){
							// 		currentData[i] = item.data[i]
							// 	}
							// }
							//console.log(currentData.fields)
							currentcells[index].setData(currentData)


						}
					})







				})
			},
			refreshNode() {
				if (this.currentNode.data.type == 'main') {
					this.$api.form.getRelation(this.extra.controll, {
						app: this.currentNode.id.slice(0, 1) == 'c' ? window.config.app : 'system',
						isonly: 1,
						type: "reflash"
					}).then((res) => {
						let cells = this.getCells(res)
						this.updatePorts(cells)
					})
				} else if (this.currentNode.data.type == 'table') {
					this.$api.form.getRelation(this.extra.controll, {
						group: this.currentNode.data.group
					}).then((res) => {
						let cells = this.getCells(res)
						cells = cells.filter((item) => {
							return item.data.type == 'table'
						})
						this.updatePorts(cells)
						//this.updatePorts(cells)
					})
				} else {
					this.$api.form.getRelation(this.extra.controll, {
						group: this.currentNode.data.group,
						index: this.currentNode.data.index
					}).then((res) => {
						let cells = this.getCells(res)
						cells = cells.filter((item) => {
							return item.data.type == 'box'
						})
						this.updatePorts(cells)
						//this.updatePorts(cells)
					})
				}




			},
			editEdge() {
				let source = this.currentEdge.source
				let target = this.currentEdge.target
				this.editTitle = '关联关系：' + this.getPortText(source) + '——' + this.getPortText(target)
				this.editShow = true
			},
			getPortText(target) {
				let cell = this.graph.getCellById(target.cell)
				let port = cell.getPort(target.port)
				let text = port.attrs.portNameLabel.text
				return text
			},
			deleteEdge() {
				this.graph.removeEdge(this.currentEdge)

			},
			getDiffPorts(ports1, ports2) {
				return ports1.concat(ports2).filter((item) => {
					let res1 = ports1.findIndex((item1) => {
						return item1.id == item.id
					})
					let res2 = ports2.findIndex((item2) => {
						return item2.id == item.id
					})
					//console.log(item.id,res1,res2)
					if (res1 === -1 || res2 === -1) {
						return true
					} else {
						return false
					}

				})
			},
			updatePorts(cells) {
				console.log(cells)
				let oldPorts = this.currentNode.port.ports
				let newPorts = cells[0].port.ports
				let diffPorts = this.getDiffPorts(oldPorts, newPorts)
				let removePorts = []
				let addPorts = []
				let totalData = []
				this.currentNode.data.fields.forEach((item) => {
					totalData.push(item)
				})
				cells[0].data.fields.forEach((item) => {
					totalData.push(item)
				})

				diffPorts.forEach((item) => {
					let buff = true
					oldPorts.forEach((_item) => {
						if (item.id == _item.id) {
							removePorts.push(_item)
							buff = false
						}
					})
					if (buff) {
						addPorts.push(item)
					}
				})
				this.currentNode.removePorts(removePorts)
				this.currentNode.addPorts(addPorts)


				let oldData = this.currentNode.data.fields
				let newData = cells[0].data.fields
				oldData.forEach((item) => {
					newData.forEach((_item) => {
						if (item.field == _item.field) {
							_item.visiable = item.visiable
							_item.button = item.button
							_item.popover = item.popover
							_item.defaultvalue = item.defaultvalue
							_item.mountcomponent = item.mountcomponent
							_item.fieldcomponent = item.fieldcomponent
							_item.componentParam = item.componentParam
							_item.listParam = item.listParam
						}
					})
				})

				this.currentNode.port.ports.forEach((item) => {
					newPorts.forEach((_item) => {
						if (item.id == _item.id) {
							this.currentNode.setPortProp(item.id, 'attrs/portNameLabel/text', _item.attrs
								.portNameLabel.text)
						}
					})
				})

				let currentData = this.currentNode.getData()
				currentData.fields = newData
				
				for(let i in currentData){
					if(i!='fields' && i!='customColumns' && i!='columns'){
						currentData[i] = cells[0].data[i]
					}
				}
				
				this.currentNode.setData(currentData)


			},
			showMenu(e) {
				e.preventDefault()
				let x = e.clientX
				let y = e.clientY
				// Get the current location
				this.contextMenuData.axis = {
					x,
					y
				}
				this.menuShow = true
			},
			modifyTask(e) {
				console.log(e)
			},
			list() {

			},
			init() {
				Graph.registerPortLayout(
					'erPortPosition',
					(portsPositionArgs) => {
						return portsPositionArgs.map((_, index) => {
							return {
								position: {
									x: 0,
									y: (index + 1) * this.LINE_HEIGHT,
								},
								angle: 0,
							}
						})
					},
					true,
				)

				Graph.registerNode(
					'er-rect', {
						inherit: 'rect',
						markup: [{
								tagName: 'rect',
								selector: 'body',
							},
							{
								tagName: 'text',
								selector: 'label',
							},
						],
						attrs: {
							rect: {
								strokeWidth: 1,
								stroke: '#5F95FF',
								fill: '#5F95FF',
							},
							label: {
								fontWeight: 'bold',
								fill: '#ffffff',
								fontSize: 12,
							},
						},
						ports: {
							groups: {
								list: {
									markup: [{
											tagName: 'rect',
											selector: 'portBody',
										},
										{
											tagName: 'text',
											selector: 'portNameLabel',
										},
										{
											tagName: 'text',
											selector: 'portTypeLabel',
										},
									],
									attrs: {
										portBody: {
											width: this.NODE_WIDTH,
											height: this.LINE_HEIGHT,
											strokeWidth: 1,
											stroke: '#5F95FF',
											fill: '#EFF4FF',
											magnet: true,
										},
										portNameLabel: {
											ref: 'portBody',
											refX: 6,
											refY: 6,
											fontSize: 10,
										},
										portTypeLabel: {
											ref: 'portBody',
											refX: 6,
											refY: 6,
											fontSize: 10,
										},
									},
									position: 'erPortPosition',
								},
							},
						},
					},
					true,
				)
			},
			createNode(label, obj, onwer = '', cells = []) {
				let fields = obj['fields']
				let node = {};

				node['data'] = obj['data'];
				node['data'].fields = fields
				node['height'] = 24;
				node['id'] = obj['name'];
				node['label'] = onwer != '' ? label + '（' + onwer + '）' : label;
				node['ports'] = [];
				node['position'] = {
					x: 0 + cells.length * 20,
					y: 0 + cells.length * 20
				};
				node['shape'] = 'er-rect';
				node['width'] = this.NODE_WIDTH;
				fields.forEach((item) => {
					let ports = {}
					ports['group'] = 'list';
					ports['id'] = item['field'];
					ports['attrs'] = {
						portNameLabel: {
							text: item['field'] + '【' + item['title'].split('|')[0] + '】'
						},
						portTypeLabel: {
							text: ''
						}
					}
					node['ports'].push(ports)
				})
				return node

			},
			reset() {
				this.currentEdge = null
				this.currentNode = null
				//const nodes = graph.getNodes()
				const edges = this.graph.getEdges()
				const nodes = this.graph.getNodes()


				// nodes.forEach((node) => {
				// 	node.attr('body/stroke', '#000')
				// })

				edges.forEach((edge) => {
					edge.attr('line/stroke', '#A2B1C3')
					// edge.prop('labels/0', {
					// 	attrs: {
					// 		body: {
					// 			stroke: 'black',
					// 		},
					// 	},
					// })
				})
				nodes.forEach((node) => {
					node.attr('rect/fill', '#5F95FF')
				})
			},
			clear() {
				this.$confirm('是否确定初始化', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.get({
						type: "clear"
					})
					// this.$api.form.deleteRelation(this.extra.name).then(() => {
					// 	this.get()
					// })
				})

			},
			get(data = {}) {
				this.$api.form.getRelation(this.extra.controll, {
					controllname: this.extra.name,
					...data
				}).then((res) => {
					if (res.json) {
						let cells = []
						if (res.type == 'init') {
							if (res.init) {
								cells = this.getCells(res)
								this.graph.resetCells(cells)
							} else {
								this.graph.fromJSON(res.json)
							}
						}
						if (res.type == 'clear') {
							cells = this.getCells(res)
							this.graph.resetCells(cells)
						}
					}
				})
			},
			getCells(res) {
				let cells = []
				for (let i in res.json) {
					if (i == 'main') {
						cells.push(this.graph.createNode(this.createNode(i, res.json[i], '', cells)))
					} else {
						for (let j in res.json[i]) {
							cells.push(this.graph.createNode(this.createNode(j, res.json[i][j], i,
								cells)))
						}
					}
				}
				return cells
			},
			getFieldFromView() {
				this.$api.form.getFieldFromView({
					view: this.customlistValue.view
				}).then((res) => {
					this.customlistValue.json = res
					console.log(res)
				})
			},
			submit() {
				this.reset()
				let edges = this.graph.getEdges()
				edges.forEach((item) => {
					let box = this.graph.getCellById(item.target.cell)
					let boxData = box.getData()
					let table = this.graph.getCellById(item.source.cell)
					table.setData({
						boxindex: boxData.index
					})

				})
				// console.log({
				// 	controllName: this.extra.name,
				// 	json: this.graph.toJSON()
				// })
				// alert(123)
				return {
					controllName: this.extra.name,
					json: this.graph.toJSON()
				}
			},
		},
		components: {
			edit,
			change,
			field,
			tablefield,
			add,
			listorder,
			vJsoneditor
		}
	}
</script>
